import { Link } from "react-router-dom";
import { SignIn } from "@clerk/clerk-react";

export function Login() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="w-full border-b border-gray-200 bg-white px-8 py-4">
        <Link to="/" className="text-xl font-semibold text-gray-900">Pull</Link>
      </header>

      <main className="flex-1 flex">
        {/* Left panel */}
        <div className="hidden md:flex flex-1 bg-[#F5D020] flex-col justify-center px-16 py-20">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Welcome back.
          </h2>
          <p className="text-lg text-gray-700 max-w-sm">
            Sign in to manage your subscriptions, track revenue, and keep your customers engaged.
          </p>
        </div>

        {/* Right panel */}
        <div className="flex-1 flex flex-col justify-center items-center px-12 py-20 bg-white">
          <SignIn routing="hash" forceRedirectUrl="/dashboard" />
        </div>
      </main>

      <footer className="w-full border-t border-gray-200 px-8 py-6 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Pull. All rights reserved.
      </footer>
    </div>
  );
}
